/* Native counterpart of the approved Canvas policy document's heading links. */
(() => {
  function initialize(root) {
    if (root.dataset.policyInitialized) return;
    root.dataset.policyInitialized = 'true';

    const contents = root.querySelector('[data-policy-content]');
    const toc = root.querySelector('[data-policy-toc]');
    if (contents && toc) {
      const usedIds = new Map();
      const links = document.createDocumentFragment();
      contents.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach((heading) => {
        const text = heading.textContent.replace(/\s+/g, ' ').trim();
        if (!text) return;
        const slug = text.normalize('NFKD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-|-$/g, '') || 'section';
        const baseId = `shopify-policy-ai-${slug}`;
        const count = (usedIds.get(baseId) || 0) + 1;
        usedIds.set(baseId, count);
        heading.id = count === 1 ? baseId : `${baseId}-${count}`;
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = text;
        link.dataset.testid = `link-policy-heading-ai-${heading.id}`;
        links.append(link);
      });
      toc.hidden = !links.childNodes.length;
      toc.append(links);
    }

    const timestamp = root.querySelector('[data-policy-fetched]');
    if (timestamp) {
      const fetchedAt = new Date().toISOString();
      timestamp.dateTime = fetchedAt;
      timestamp.textContent = fetchedAt;
    }
    root.querySelector('[data-policy-retry]')?.addEventListener('click', () => window.location.reload());
  }

  function initializeWithin(container) {
    container.querySelectorAll('[data-astrobrew-ai-policy]').forEach(initialize);
  }

  initializeWithin(document);
  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();